<template>
  <a-spin tip="加载中..." :spinning="spinning">
    <a-card
      v-if="open_maintain_service==='YES'"
      class="mt-20"
      :bordered="false"
    >
      <!-- 表格筛选 start -->
      <a-form layout="inline">
        <a-form-item class="mr-20">
          <a-input-group compact style="width: 300px">
            <a-input placeholder="购买时间" disabled style="width: 80px;text-align:center" />
            <a-range-picker v-model="querytimeRange" style="width: 220px;"/>
          </a-input-group>
        </a-form-item>
        <a-form-item class="mr-20">
          <a-input
            addon-before="用户手机号"
            v-model="queryParam.phone"
            placeholder="用户手机号"
            allowClear
          />
        </a-form-item>
        <!-- <a-form-item class="mr-20">
          <a-input
            addon-before="用户ID"
            v-model="queryParam.uid"
            placeholder="用户ID"
            allowClear
          />
        </a-form-item> -->
        <a-form-item class="mr-20">
          <a-input
            addon-before="产品名称"
            v-model="queryParam.goods_name"
            placeholder="产品名称"
            allowClear
          />
        </a-form-item>
        <a-form-item class="mr-20">
          <a-input-group compact style="width: 360px">
            <a-input
              addon-before="支付金额"
              style="width: 50%;"
              v-model="queryParam.start_money"
              placeholder="开始金额"
            />
            <a-input
              style="width: 50%;"
              addon-before="元至"
              v-model="queryParam.end_money"
              addon-after="元"
              placeholder="结束金额"
            />
          </a-input-group>
        </a-form-item>
        <a-form-item>
          <a-button
            class="mr-10"
            type="primary"
            @click="handleFilter"
          >
            搜索
          </a-button>
          <a-button @click="handleReset">
            重置
          </a-button>
        </a-form-item>
      </a-form>
      <!-- 表格筛选 end -->
      <!-- 表格内容操作 start -->
      <div class="mt-20">
        <a-button
          type="primary"
          class="mr-20"
          @click="handleExport"
        >导出</a-button>
      </div>
      <!-- 表格内容操作 end -->
      <!-- 表格 start -->
      <tcg-table
        ref="table"
        size="default"
        :columns="columns"
        :data="loadData"
        bordered
        class="mt-20"
      >
        <a
          type="link"
          slot="phone"
          slot-scope="text, record"
          @click="handleToUser(record.uid)"
        >
          {{ text }}
        </a>
        <span
          slot="pay_money"
          slot-scope="text"
        >
          ￥{{ text }}
        </span>
      </tcg-table>
      <!-- 表格 end -->
    </a-card>
    <a-result v-else status="403" title="延保服务暂未开通" sub-title="无法使用，请联系业务经理进行升级"/>
  </a-spin>
</template>

<script>
import { TcgTable } from '@/components'
import { getMaintainList, checkService } from '@/api/maintain'
import { downloadFile } from '@/utils'

const defaultQueryParam = {
  phone: ''
}

export default {
  name: 'MaintainList',
  components: { TcgTable },
  data() {
    return {
      spinning: true, // 页面加载。。
      open_maintain_service: 'YES',
      querytimeRange: [], // 选择时间
      queryParam: Object.assign({}, defaultQueryParam),
      // 加载数据方法 必须为 Promise 对象
      loadData: (parameter) => {
        if (this.querytimeRange.length) {
          this.queryParam.start_time = this.querytimeRange[0].format('YYYY-MM-DD')
          this.queryParam.end_time = this.querytimeRange[1].format('YYYY-MM-DD')
        } else {
          this.queryParam.start_time = null
          this.queryParam.end_time = null
        }
        return getMaintainList(Object.assign(parameter, this.queryParam)).then((res) => {
          return res
        })
      },
      columns: [
        {
          title: 'ID',
          dataIndex: 'id'
        },
        {
          title: '订单号',
          dataIndex: 'mt_orderId'
        },
        {
          title: '云码',
          dataIndex: 'code'
        },
        {
          title: '所属品牌',
          dataIndex: 'brand_name'
        },
        {
          title: '购买时间',
          dataIndex: 'pay_time'
        },
        {
          title: '用户手机号',
          dataIndex: 'phone',
          scopedSlots: { customRender: 'phone' }
        },
        {
          title: '产品',
          dataIndex: 'goods_name'
        },
        {
          title: '购买选项',
          dataIndex: 'term'
        },
        {
          title: '支付金额',
          dataIndex: 'pay_money',
          scopedSlots: { customRender: 'pay_money' }
        },
        {
          title: '保修延长到期时间',
          dataIndex: 'expires_time'
        }
      ]
    }
  },
  created () {
    this.checkService()
    // 查询用户
    if (this.$route.query.phone) {
      this.queryParam.phone = this.$route.query.phone
      this.$nextTick(() => {
        this.$refs.table.refresh(true)
      })
    }
  },
  methods: {
    handleFilter() {
      this.$refs.table.refresh(true)
    },
    handleReset() {
      this.queryParam = Object.assign({}, defaultQueryParam)
      this.querytimeRange = []
      this.$refs.table.refresh(true)
    },
    // 导出
    handleExport() {
      const href = window.location.origin + '/merchant.php/maintain/outExcel'
      downloadFile(href)
    },
    // 跳转到用户
    handleToUser(uid) {
      this.$router.push({ name: 'memberIndex', query: { uid } })
    },
    // 检查服务
    checkService() {
      this.spinning = true
      checkService()
        .then((res) => {
          if (res.code === 200) {
            this.open_maintain_service = res.data.open_maintain_service
          } else {
            this.$message.error('检查服务失败')
          }
        })
        .catch((e) => {
          this.$message.error('检查服务失败')
        })
        .finally(() => {
          this.spinning = false
        })
    }
  }
}
</script>
